import { render } from "./BasketSummary.vue?vue&type=template&id=5c63ea98"
import script from "./BasketSummary.vue?vue&type=script&lang=js"
export * from "./BasketSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__